import { IPassportGroup } from '@/pages/MDM/mdm.types'
import ThreeDotsLoader from '@/shared/Loaders/ThreeDotsLoader'
import useTreeSelectCtrl from '@/shared/Tree/ctrl/useTreeSelectCtrl'
import domUtils from '@/utils/dom.utils'
import { useEffect, useRef, useState } from 'react'
import EquipmentPassportTree from '../../EquipmentFormFields/EquipmentPassportTree'
import { IEquipment, IEquipmentPassport, IPrevEquipmentPassportVersion } from '@/pages/Equipment/equipment.types'
import equipmentApi from '@/pages/Equipment/equipment.api'
import useHttpLoader from '@/shared/hooks/useHttpLoader'
import useEquipmentPassport from '@/pages/Equipment/hooks/useEquipmentPassport'
import css from '../equipmentPassportVersions.module.css'
import passportVersionsConstants from '../passportVersions.constants'
import EquipmentPassportView from '../../../Passport/EquipmentPassportView'

interface IProps {
  equipment: IEquipment
  equipmentPassportVersionId: IPrevEquipmentPassportVersion['id']
}

const EquipmentPassportVersionsViewContent = (props: IProps) => {
  const tableRef = useRef<HTMLDivElement>(null)
  const { passport: currentPassportInstance } = useEquipmentPassport(props.equipment?.passportInstanceId)
  const [passport, setPassport] = useState<IEquipmentPassport>(currentPassportInstance)
  const { wait, loading } = useHttpLoader()

  useEffect(() => {
    if (props.equipmentPassportVersionId !== passportVersionsConstants.currentVersionId) {
      wait(equipmentApi.getHistoricalPassportData(props.equipment.id, props.equipmentPassportVersionId), (resp) => {
        if (resp.status === 'success') {
          setPassport(resp.body.passportInstance)
        }
      })
    } else {
      setPassport(currentPassportInstance)
    }
  }, [props.equipment, props.equipmentPassportVersionId, currentPassportInstance])

  const groupSelectCtrl = useTreeSelectCtrl<IPassportGroup['id']>(
    `/equipment/lifts/passportVersions/isVersionComparisonDisabled`,
    null,
    'regularState'
  )

  const handleGroupSelect = (groupId: IPassportGroup['id']) => {
    const targetElement = tableRef.current?.querySelector(`#groupId_${groupId}`) as HTMLElement
    domUtils.scrollToTargetElement(targetElement)
    groupSelectCtrl.handleSelect(groupId)
  }

  if (!passport || loading) {
    return (
      <div className="flex-lines center height100 width100">
        <ThreeDotsLoader inscription="Загрузка..." />
      </div>
    )
  }

  return (
    <div
      className="inline-flex-gap gap24 height100"
      style={{ minHeight: 0, overflow: 'auto', flex: '1 1 0%', paddingRight: '18px' }}
    >
      <div className={css.passportNavBlock}>
        <EquipmentPassportTree
          selectCtrl={groupSelectCtrl}
          passportSchemaId={passport.passportId}
          handleSelect={handleGroupSelect}
        />
      </div>
      <EquipmentPassportView
        passportInstance={passport}
        ref={tableRef}
        onGroupIntoViewportChange={groupSelectCtrl.handleSelect}
      />
    </div>
  )
}

export default EquipmentPassportVersionsViewContent
